import React from 'react';
import PropTypes from 'prop-types';
import { Box, Button } from '@mui/material';
import { useHistory } from 'react-router-dom';
import CarouselStyles from './style';

function ExploreButton({ text, iconUrl, navigateTo }) {
    const history = useHistory();
    const handleClick = () => {
        history.push(navigateTo);
    };
    return (
        <Button sx={CarouselStyles.ExploreButton.button} disableRipple onClick={handleClick}>
            <Box sx={CarouselStyles.ExploreButton.content}>
                <Box component="img" src={iconUrl} alt="" sx={CarouselStyles.ExploreButton.icon} />
                <Box component="span" sx={CarouselStyles.ExploreButton.text}>
                    {text}
                </Box>
            </Box>
        </Button>
    );
}

ExploreButton.propTypes = {
    text: PropTypes.string.isRequired,
    iconUrl: PropTypes.string.isRequired,
    navigateTo: PropTypes.string.isRequired,
};

export default ExploreButton;
